import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CustomizedTables, { Action } from '../../atoms/table';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import Dialog from "../../atoms/dialog";
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomizedDialogs from '../../atoms/dialog';
import { makeStyles } from '@material-ui/core/styles';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { handleSnackBar, invokeGetService, invokePostService } from '../../../store/global/actions';
import config from '../../../config';
import ConfigurationJsonEditor from '../../atoms/jsonFormEditor/ConfigurationJsonEditor';

const API_URL = config.apiV2Url;

const useStyles = makeStyles((theme) => ({
    typography: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(5, 10, 5, 40),
    },

    textCapitalise: {
        textTransform: 'capitalize'
    }
}));



const GitConfiguration = () => {

    const classes = useStyles();

    const dispatch = useDispatch();

    const [dialogBox, setDialogBox] = useState(false);
    const [action, setAction] = useState("");
    const [loading, setLoading] = useState(false)
    const [testLoading, setTestLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [editor, setEditor] = useState(null);
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [configurationData, setConfigurationData] = useState([]);
    const [deleteSchema, setDeleteSchema] = useState(null);
    const [saving, setSaving] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [testing, setTesting] = useState(false)

    useEffect(() => {
        setLoading(true);
        getGitConfiguration();

    }, []);

    let schema = {
        type: 'object',
        options: {
            display: false,
            layout: 'grid',
            disable_properties: 'false'
        },
        required: ["url", "password"],
        properties: {
            url: {
                title: 'Git repository url',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
            password: {
                title: 'Password',
                type: 'string',
                format: 'password',
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            }
        },
    }

    const placeholders = [
        {
            item: "url",
            placeholder: 'username@ip:/path/to/example.git',
        },
        {
            item: "password",
            placeholder: "password"
        }
    ]

    const defaultOptions = {
        theme: 'bootstrap4',
        iconlib: "fontawesome4",
        disable_collapse: true,
        compact: true,
        no_additional_properties: true,
        disable_edit_json: true,
        disable_properties: true,
        disable_add_remove: true,
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const options = {
        form_name_root: "git_configuration",
        show_errors: "never"
    }

    const onChangeJsonEditor = (data) => {
        // console.log("onChangeJsonEditor---------", {data})
        // For hide the the title
        const elementToDisable = document.querySelectorAll('.card-title');
        if (elementToDisable) {
            elementToDisable.forEach(element => {
                element.style.display = 'none';
            });
        }
    }

    const dialogHandleClose = () => setDialogBox((prev) => !prev);

    const formatGitConfiguration = ({ url, password }) => {
        return {url, password}
    }

    const onSave = (data) => {
        setSaving(true)
        let configData = {}
        configData = formatGitConfiguration(data);

        if (action == "edit") {
            updateGitConfiguration(configData)
        } else {
            saveGitConfiguration(configData)
        }
    }

    const deleteGitConfiguration = async () => {
        try {
            dispatch(invokePostService('deleteGitConfiguration', {})).then(response => {
                if (response.status) {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                    setDeleteSchema(null)
                    setDeleteLoader(false)
                    setOpen(false)
                    setLoading(true);
                    getGitConfiguration();
                }else{
                    if(response.message){
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }));
                    }
                }
            }).catch(error => {
                console.error("Error while deleting git config. ", error)
            })


        } catch (err) {
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }))
        }
    }


    const saveGitConfiguration = async (data) => {
        try {
            dispatch(invokePostService('createGitConfiguration', {data}, [])).then(response => {
                setSaving(false);
                // console.log({response})
                if (response?.status) {
                    dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'success' }));
                    setDialogBox(false);
                    setLoading(true);
                    getGitConfiguration();
                } else {
                    if(response?.message != undefined){
                        dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
                    }
                    
                }

            }).catch(error => {
                console.error("Error while adding git config. ",error);
            })

        } catch (err) {
            console.error("Errow while saving configuration. ", err);
        }
    }

    const updateGitConfiguration = async (data) => {
        try {
            dispatch(invokePostService('updateGitConfiguration', {data}, [])).then(response => {
                // console.log({response})

                setSaving(false);
                if (response.status) {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                    setDialogBox(false);
                    setLoading(true)
                    getGitConfiguration();
                } else {
                    if(response?.message){
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }));
                    }
                }
            }).then(error => {
                console.error("Error while updating git configuration. ", error)
            })


        } catch (err) {
            console.error("Error while updating git configuration. ", err);
        }
    }

    const getGitConfiguration = () => {
        try {
            setLoading(true)
            dispatch(invokeGetService('getGitConfiguration', {})).then(response => {
                // console.log({response})
                if(response.status){
                    setLoading(false)
                    setConfigurationData(response.data === null ? [] : [response.data]);
                }else{
                    if(response.message){
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
                    }
                }
            }).catch(error => {
                console.error("Error while fetching git configuration. ", error);
            })

            
        } catch (err) {
            console.error("Error while fetching git configuration. ", err)
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration`, severity: 'error' }))
        }
    }

    const getGitConfigInformation = () => {
        try {
            configurationData.forEach(config => {
                setSelectedConfig({
                    url: config.url,
                    password: config.password
                })
            })
            setFormLoading(false)
        } catch (err) {
            console.error("Error: ", err)
            dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration data`, severity: 'error' }))
        }
    }

    const onSubmit = () => {
        const data = editor.getValue();

        const validateErrors = validateWithError(data)

        if (validateErrors.length) {
            setErrorElementsInForm(validateErrors)
            return
        }
        onSave(data);
    }

    const setErrorElementsInForm = (validationErrors) => {
        // console.log({validationErrors})
        
        validationErrors.forEach(error => {
            // console.log({error})

            let path = error.path.split('.')

            let elementName = `${path[0]}[${path[1]}]`

            let ele = document.getElementById(elementName)
            if(ele != undefined){
                let errorElement = `<p id="validation-error-${error.path}" class="text text-danger gitConfig-validation-error" style="font-family: Roboto,Helvetica;">${error.message}</p>`
                ele.insertAdjacentHTML("afterend", errorElement)
            }
        })
    }

    const validateWithError = (data) => {
        const { url, password } = data;

        clearErrors();
        let errors = []

        let prefix = options.form_name_root + "."
        
        if(/\s/.test(url)){
            errors.push({
                path: prefix + "url",
                property: "format",
                message: "Repository url should not contain any space"
            })
        }
        if (url === "") {
            errors.push({
                path: prefix + "url",
                property: "format",
                message: "Repository url required"
            })
        }

        if (password === "") {
            errors.push({
                path: prefix + "password",
                property: "format",
                message: "Password cannot be empty"
            })
        }

        return errors;
    }

    const clearErrors = () => {
        const errorDivs = document.querySelectorAll(".gitConfig-validation-error");

        for (let i = 0; i < errorDivs.length; i++) {
            errorDivs[i].remove();
        }
    }

    const onClose = () => {
        setDialogBox(false);
    }


    const addGitConfiguration = () => {
        setDialogBox(true)
        setAction("add")
        setSelectedConfig(null);
    }

    const deleteData = (data) => {
        setOpen(true)
        setDeleteSchema(data)
    }

    const handleDelete = () => {
        setDeleteLoader(true);
        deleteGitConfiguration();
    }

    /** Test configuration */
    const testConfiguration = () => {
        const data = editor.getValue();
        const validateErrors = validateWithError(data)

        if (validateErrors.length) {
            setErrorElementsInForm(validateErrors)
            return
        }

        setTesting(true)
        dispatch(invokePostService('testSimulationConfig', data)).then(response => {
            setTesting(false)
            dispatch(handleSnackBar({ open: true, message: response.message, severity: response.status ? 'success' : 'error' }));
        })
    }

    // console.log({configurationData})
    return (
        <Grid  container direction="row" spacing={2}>

            <CustomizedDialogs
                open={open}
                title="Delete"
                handleClose={() => setOpen(false)}
                container_id="delete_git_configuration_modal"
                actions={
                    <React.Fragment>
                        <Button className={classes.textCapitalise} autoFocus onClick={() => setOpen(false)} variant="outlined" color="primary">
                            Cancel
                        </Button>
                        <Button id="delete_git_configuration" className={classes.textCapitalise}  autoFocus variant="contained" color="secondary" onClick={handleDelete} disabled={deleteLoader} startIcon={deleteLoader ? <CircularProgress color="secondary" size={20} /> : <Fragment />}>
                            {deleteLoader ? "Deleting.." : "Delete"}
                        </Button>
                    </React.Fragment>
                }>
                <Typography>Do you want to delete the Git configuration?</Typography>
            </CustomizedDialogs>

            {configurationData.length < 1 &&
            <Grid container direction="row" alignItems="center" justify="center" style={{ padding: 10, justifyContent: 'end' }}>
                <Button id="add_git_configuration" onClick={() => addGitConfiguration()} variant="contained" className={classes.textCapitalise} > Add Git Configuration </Button>
            </Grid>
            }

            <Grid item xs={12}>
                <GitConfigurationTable getGitConfigInformation={getGitConfigInformation} configurationData={configurationData} deleteData={deleteData} dialogBox={setDialogBox} action={setAction} dispatch={dispatch} loading={loading} toggleLoading={setFormLoading} />
            </Grid>

            <Grid item xs={12}>
                {dialogBox && (

                    <Dialog
                        title={action === "add" ? "Add Git Configuration" : "Edit Git Configuration"}
                        handleClose={dialogHandleClose}
                        open={true}
                        paperProps={{ id: "add_git_cofniguration_modal" }}

                        actions={
                            <>
                                <Button onClick={() => onClose()} color="primary" variant="outlined" style={{ marginRight: 10 }} id={"clear_git_config"} className={classes.textCapitalise}>
                                    Close
                                </Button>
                                {/* <Button id={'test-simulation-config'} onClick={() => testConfiguration()} disabled={testing} type="submit" color="primary" variant="contained" className={classes.textCapitalise}>
                                    Test Configuration
                                </Button> */}
                                <Button onClick={() => onSubmit()} disabled={saving} type="submit" color="primary" variant="contained" className={classes.textCapitalise} id={"save_git_config"}>
                                    Save
                                </Button>
                            </>
                        }
                    >
                        <Grid container direction="row" style={{ padding: '0.5rem' }} spacing={2}>
                            {formLoading ?
                                <LoaderWithProgress size={20} isContent={true} styleRoot={{ height: '28vh', width: '100%' }} />
                                :
                                <ConfigurationJsonEditor setEditor={setEditor} options={options} defaultOptions={defaultOptions} schema={schema} schemaValues={selectedConfig} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="json_simulationconfig_editor" placeholders={placeholders} />
                            }
                        </Grid>
                    </Dialog>
                )}

            </Grid>
        </Grid>
    )
}
export default GitConfiguration;



const headers = [
    { label: 'Repository url', name: 'url' },
];

const GitConfigurationTable = ({ configurationData = [], getGitConfigInformation, deleteData, dialogBox, action, loading, toggleLoading }) => {

    const onMenuClick = (data) => (key) => {

        switch (key) {
            case 'edit':
                dialogBox(true)
                toggleLoading(true)
                action("edit")
                getGitConfigInformation(data?._id);
                break;

            case 'delete':
                deleteData(data);
                break;
        }
    };
    return (
        <CustomizedTables size="small" headers={headers} actions id={"git_configuration_table"}>
            {
                loading ?
                    <StyledTableRow>
                        <StyledTableCell align={'center'} colSpan={11} component="td" style={{ padding: 15 }}>
                            Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                        </StyledTableCell>
                    </StyledTableRow>
                    : configurationData.length < 1 ?
                        <StyledTableRow>
                            <StyledTableCell align={'center'} colSpan={11} component="td" style={{ padding: 15 }}>
                                No git configuration available.
                            </StyledTableCell>
                        </StyledTableRow> : configurationData.map((item, index) => {

                            return (
                                <StyledTableRow>
                                    <StyledTableCell align={'center'}>{item.url || ''}</StyledTableCell>
                                    <Action onMenuClick={onMenuClick(item)} showCloneBtn={false} index={index} />
                                </StyledTableRow>
                            );
                        })
            }
        </CustomizedTables>
    )
};